import { useEffect } from 'react';
import useWebSocket, { ReadyState as ruwReadyState } from 'react-use-websocket';

const SOCKET_URL = 'wss://' + window.location.hostname + '/socket';
let activeUsers = [];
let started = false;

export const ReadyState = ruwReadyState;

export function useSocket() {
    const {
        lastJsonMessage,
        sendJsonMessage,
        readyState,
    } = useWebSocket(SOCKET_URL, {
        share: true,
        shouldReconnect: () => true,
        onOpen: (ev) => {
            sendJsonMessage({
                "action": "subscribe",
                "type": "type",
                "value": "active",
            })
        }
    });

    const sendPing = () => {
        sendJsonMessage({
            "action": "ping",
        });

        setTimeout(sendPing, 5000);
    }

    if (!started) {
        sendPing();
        started = true;
    }

    useEffect(
        () => {
            if (lastJsonMessage !== null) {
                const { type, payload } = lastJsonMessage;
                if (type === 'active') {
                  activeUsers = !payload ? [] : payload;
                }
            }
        }, [lastJsonMessage, sendJsonMessage]
    );

    return {
      users: activeUsers,
      state: readyState,
    }
}
